import React from "react"
import Icon from "@ant-design/icons"

const YoutubeSVG = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3008 5.64453C19.0898 4.80078 18.4219 4.13281 17.6133 3.92188C16.1016 3.5 10.125 3.5 10.125 3.5C10.125 3.5 4.11328 3.5 2.60156 3.92188C1.79297 4.13281 1.125 4.80078 0.914062 5.64453C0.492188 7.12109 0.492188 10.2852 0.492188 10.2852C0.492188 10.2852 0.492188 13.4141 0.914062 14.9258C1.125 15.7695 1.79297 16.4023 2.60156 16.6133C4.11328 17 10.125 17 10.125 17C10.125 17 16.1016 17 17.6133 16.6133C18.4219 16.4023 19.0898 15.7695 19.3008 14.9258C19.7227 13.4141 19.7227 10.2852 19.7227 10.2852C19.7227 10.2852 19.7227 7.12109 19.3008 5.64453ZM8.15625 13.1328V7.4375L13.1484 10.2852L8.15625 13.1328Z"
      fill="#FF6900"
    />
  </svg>
)

const Youtube = props => <Icon component={YoutubeSVG} {...props} />

export default Youtube
